import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"
import { getCustomerList } from "../../../services/Settings/dropdown"

function ucfirst(str) {
  var firstLetter = str.substr(0, 1)
  return firstLetter.toUpperCase() + str.substr(1)
}
const Customer = ({
  control,
  name,
  onSelectChange,
  target,
  placeholder,
  fromFilter,
  onCreate,
  showCreateOption = false,
  refreshKey, 
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [fetchResponse, setFetchResponse] = useState([]);

  const loadOptions = async () => {
    const data = await getCustomerList();
    setIsLoading(false);
    const response = data?.data?.map(dta => ({
      label: dta?.customer_code && ucfirst(
        fromFilter
          ? dta.customer_code
          : `${dta.customer_code}-${ucfirst(dta?.customer_name)}`
      ),
      value: dta.id,
      ...dta,
    }));

    const options = [...response];
    
    if (showCreateOption) {
      options.unshift({
        label: "Create",
        value: "create",
        isCreateButton: true,
      });
    }

    setFetchResponse(options);
  };
  
  useEffect(() => {
    loadOptions();
  }, [refreshKey]);

  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, ref, value } }) => (
          <Select
            options={fetchResponse}
            // placeholder={placeholder || "Select"}
            placeholder={
              <div className="css-placeholder">
                {placeholder || "Select"} 
              </div>
            }
            isLoading={isLoading}
            inputRef={ref}
            onChange={(e) => {
              if (e?.isCreateButton) {
                onCreate(); // Trigger the create function
              } else {
                onChange(e);
                onSelectChange?.(e);
              }
            }}
            value={value}
            classNamePrefix="react-select"
            className="elevate-dropdown"
            menuPortalTarget={document.querySelector(
              target ? target : ".modal"
            )}
          />
        )}
      />
    </div>
  );
};

export default Customer